import React from 'react';
import SlotRenderer from '@plone/volto/components/theme/SlotRenderer/SlotRenderer';
import { FormattedMessage } from 'react-intl';

type ErrorLayoutProps = {
  title?: React.ReactNode;
  children: React.ReactNode;
  slotContent?: any;
};

const ErrorLayout: React.FC<ErrorLayoutProps> = ({
  title,
  children,
  slotContent = {},
}) => {
  return (
    <>
      <article id="page-document" className="has-aside">
        <section className="content">
          <div className="blocks-group-wrapper transparent">
            <h1 className="hero__title">
              {title ?? (
                <FormattedMessage
                  id="error.genericHeroTitle"
                  defaultMessage="Something went wrong"
                />
              )}
            </h1>
            {children}
          </div>
        </section>

        <aside className="sidebar-nav-right-wrapper">
          <div className="sidebar-navigation-container">
            <div className="sub-navigation-container">
              <SlotRenderer name="sidebar-nav-right" content={slotContent} />
            </div>
          </div>
        </aside>
      </article>
    </>
  );
};

export default ErrorLayout;
